import { Box, List, ListItem, Stack, Typography } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import dayjs from 'dayjs';

import { IOfferLetter } from '../../type';
import { PdfPage } from '../pdf-page';

interface Props {
  methods: UseFormReturn<IOfferLetter>;
}

const JoiningDetails = ({ methods }: Props) => {
  const form = methods.watch();

  const listStyle = { display: 'list-item', padding: 0 };

  return (
    <PdfPage>
      <Stack gap={1.5}>
        <Typography variant="subtitle1" sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          Joining Details:
        </Typography>
        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          {`- Joining Date: ${dayjs(form.joiningDate).add(1, 'day').format('DD-MMM-YYYY')}`}
          <br />
          {`- Reporting time on first day of joining: 10:00am`}
          <br />
          {`- Office Start Time: 9:30am`}
        </Typography>

        <Box />

        <Typography variant="subtitle1" sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          Documents to submitted:
        </Typography>
        <List sx={{ listStyleType: 'disc', pl: 2, pt: 0 }}>
          <ListItem sx={listStyle}>
            <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
              Scanned copies need to be submitted to the HR Team on mail before joining. Original
              will be required on the joining day for verification.
            </Typography>
          </ListItem>
          <ListItem sx={listStyle}>
            <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
              Marks cards starting from SSLC or equivalent, to Graduation / Post Graduation, as
              applicable.
            </Typography>
          </ListItem>
          <ListItem sx={listStyle}>
            <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
              Degree certificates.
            </Typography>
          </ListItem>
          <ListItem sx={listStyle}>
            <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
              Offer letters, increment letters, relieving letters, as applicable. For last up to 3
              organizations, if applicable.
            </Typography>
          </ListItem>
          <ListItem sx={listStyle}>
            <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>PAN Card</Typography>
          </ListItem>
          <ListItem sx={listStyle}>
            <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>Aadhar Card</Typography>
          </ListItem>
        </List>

        <Box />

        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          We look forward to your joining in our dream team!
        </Typography>
        <Typography sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>Your Sincerely</Typography>
        <Typography variant="subtitle1" sx={{ fontFamily: 'Verdana', lineHeight: 1.2 }}>
          SyncGlob Pvt. Ltd.
        </Typography>
      </Stack>
      <Stack justifyContent={'end'} alignItems={'start'}>
        <Stack width={150} mt={'20px'}>
          <img src={'/assets/images/jatin-soni.png'} />
        </Stack>
        -----------------------------
      </Stack>
    </PdfPage>
  );
};

export default JoiningDetails;
